export default __webpack_public_path__ + "static/media/woman-patient-dentist.1e3a7d9c.jpg";